import {CheckoutService} from '@/common/api/checkout.service'
import {
    CHECKOUT_CREATE,
    CHECKOUT_EDIT,
    CHECKOUT_DELETE,
    CHECKOUT_GET,
    CHECKOUTS_GET,
    CHECKOUTS_BM_GET,
    CHECKOUT_ACTIVE,
    CHECKOUT_INACTIVE,
    CHECKOUT_SCHEDULES_GET,
    CHECKOUT_CHARGE,
    CHECKOUT_STATUS_LIST_GET,
    CHECKOUT_SEARCH,
    CHECKOUT_SCHEDULE_GET
} from './actions/checkout.type.js'
import {
    SET_CHECKOUT,
    SET_CHECKOUTS,
    SET_CHECKOUTS_STATUS_LIST,
    SET_CHECKOUT_PAGINATION,
    SET_CHECKOUT_SCHEDULES_PAGINATION,
    SET_CHECKOUT_ACTIVE,
    SET_CHECKOUT_SCHEDULES,
    CHECKOUT_RESET,
    CHECKOUT_RESET_STATE,
    SET_CHECKOUT_SCHEDULE,
} from './mutations/checkout.type.js'

import {CHANGE_PROGRESS} from './mutations/mutations.type.js'

const initialState = () => {
    return {
        checkout: {
            id: 0,
            name: "",
            phone: "",

            bsBMs: [],
        },
        checkoutStatusList: [],
        checkoutPagination: {
            search: "",
            itemsPerPage: 10,
            orderBy: "",
            sortDesc: false,
            date: null,
            status: null
        },

        checkouts: {
            active: true,
            activePage: 1,
            totalPages: 1,
            totalItems: 1,
            items: []
        },

        checkoutSchedulesPagination: {
            itemsPerPage: 10,
            orderBy: "",
            sortDesc: false,
            date: null
        },
        checkoutSchedules: {
            activePage: 1,
            totalPages: 1,
            totalItems: 1,
            items: []
        },
        checkoutSchedule: {
            id: 0,
            bmID: 0,
            bmName: "",
            serviceID: 0,
            serviceName: "",
            personID: 0,
            personName: "",
            personPhone: "",
            statusID: 0,
            startTime: "",
            endTime: "",
            appUser: false,
            createdAt: "",
            order:{
                items:[]
            }
        }

    }
}

export const state = initialState()

const getters = {
    checkout: state => {
        return state.checkout
    },
    checkouts: state => {
        return state.checkouts
    },
    checkoutStatusList: state => {
        return state.checkoutStatusList
    },
    checkoutPagination: state => {
        return state.checkoutPagination
    },
    checkoutSchedulesPagination: state => {
        return state.checkoutSchedulesPagination
    },
    checkoutSchedules: state => {
        return state.checkoutSchedules
    },
    checkoutSchedule: state => {
        return state.checkoutSchedule
    }
}

export const mutations = {
    [SET_CHECKOUT](state, data) {
        state.checkout = data
    },
    [SET_CHECKOUTS](state, data) {
        state.checkouts = data
    },
    [SET_CHECKOUT_PAGINATION](state, data) {
        state.checkouts.activePage = data.page
        state.checkoutPagination.itemsPerPage = data.itemsPerPage
        state.checkoutPagination.orderBy = data.orderBy
        state.checkoutPagination.sortDesc = data.sortDesc
        state.checkoutPagination.endDate = data.endDate
        state.checkoutPagination.startDate = data.startDate
    },
    [SET_CHECKOUT_SCHEDULES_PAGINATION](state, data) {
        state.checkoutSchedules.activePage = data.page
        state.checkoutSchedules.itemsPerPage = data.itemsPerPage
        state.checkoutSchedules.orderBy = data.orderBy
        state.checkoutSchedules.sortDesc = data.sortDesc
    },
    [SET_CHECKOUT_ACTIVE](state, active) {
        state.checkout.active = active
    },
    [SET_CHECKOUTS_STATUS_LIST](state, data) {
        state.checkoutStatusList = data
    },
    [SET_CHECKOUT_SCHEDULES](state, data) {
        state.checkoutSchedules = data
    },
    [SET_CHECKOUT_SCHEDULE](state, data) {
        state.checkoutSchedule = data
    },
    [CHECKOUT_RESET](state) {
        Object.assign(state.checkout, initialState().checkout)
    },
    [CHECKOUT_RESET_STATE](state) {
        let ck = {}
        Object.assign(ck, state.checkoutPagination)
        Object.assign(state, initialState())
        state.checkoutPagination = ck
    },
}

export const actions = {
    async [CHECKOUTS_GET]({commit, state}) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await CheckoutService.list(state.checkouts.activePage, state.itemsPerPage, state.checkouts.active)
        commit(SET_CHECKOUTS, data)
        commit(CHANGE_PROGRESS, false)
    },

    async [CHECKOUT_GET]({commit}, id) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await CheckoutService.get(id)
        commit(SET_CHECKOUT, data)
        commit(CHANGE_PROGRESS, false)
    },
    async [CHECKOUTS_BM_GET]({commit}, id) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await CheckoutService.bmServices(id)
        commit(SET_CHECKOUTS, data)
        commit(CHANGE_PROGRESS, false)
    },
    async [CHECKOUT_SEARCH]({commit, state}) {
        // commit(CHANGE_PROGRESS, true)

        const {data} = await CheckoutService.search(
            state.checkouts.activePage,
            state.checkoutPagination.itemsPerPage,
            state.checkoutPagination.status,
            state.checkoutPagination.search,
            state.checkoutPagination.orderBy,
            state.checkoutPagination.sortDesc,
            state.checkoutPagination.startDate,
            state.checkoutPagination.endDate)
        commit(SET_CHECKOUTS, data)
        // commit(CHANGE_PROGRESS, false)
    },
    async [CHECKOUT_SCHEDULES_GET]({commit, state}, id) {
        commit(CHANGE_PROGRESS, true)

        const {data} = await CheckoutService.getSchedules(
            id,
            state.checkoutSchedules.activePage,
            state.checkoutSchedulesPagination.itemsPerPage,
            state.checkoutSchedulesPagination.orderBy,
            state.checkoutSchedulesPagination.sortDesc)
        commit(SET_CHECKOUT_SCHEDULES, data)
        commit(CHANGE_PROGRESS, false)
    },
    async [CHECKOUT_SCHEDULE_GET]({commit}, ids) {
        commit(CHANGE_PROGRESS, true)

        const {data} = await CheckoutService.get(ids.personID, ids.scheduleID)
        commit(SET_CHECKOUT_SCHEDULE, data)
        commit(CHANGE_PROGRESS, false)
    },
    async [CHECKOUT_STATUS_LIST_GET]({commit}) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await CheckoutService.listStatus()
        commit(SET_CHECKOUTS_STATUS_LIST, data)
        commit(CHANGE_PROGRESS, false)
    },
    [CHECKOUT_CREATE]({state}) {
        return CheckoutService.create(state.checkout)
    },
    [CHECKOUT_EDIT]({state}) {
        return CheckoutService.update("", state.checkout)
    },
    [CHECKOUT_CHARGE](_, data) {
        return CheckoutService.checkoutCharge(data.id, data.obj)
    },
    [CHECKOUT_ACTIVE](_, id) {
        return CheckoutService.active(id)
    },
    [CHECKOUT_INACTIVE](_, id) {
        return CheckoutService.inactive(id)
    },
    [CHECKOUT_DELETE](_, data) {
        return CheckoutService.delete(data.personID, data.scheduleID)
    },
    [CHECKOUT_RESET_STATE]({commit}) {
        commit(CHECKOUT_RESET_STATE)
    }
}
export default {
    state,
    actions,
    mutations,
    getters
}
